import { Grid } from "@mui/material"
import ImageCanvas from "../../../components/OverviewView/ImageCanvas"
import OverviewInfo from "../../../components/OverviewView/OverviewInfo"
import { SolveAdjudicationCaseDecision, SolveAdjudicationCaseAttack, AdjudicationPendingOperation, AdjudicationSolvedOperation } from "neurotec-megamatcherid-management-client-adjudicator"
import { Modality } from "../../../Store/Operations/types"
import { Operation } from "neurotec-megamatcherid-management-client"


interface IAdjudicationOverview {
    disableAction?: boolean
    handleSolve: (decision: SolveAdjudicationCaseDecision, attack: SolveAdjudicationCaseAttack) => void
    adjudication: AdjudicationPendingOperation & AdjudicationSolvedOperation
}

const AdjudicationOverview: React.FC<IAdjudicationOverview> = (props) => {

    return (
        <Grid container>
            <Grid item xs={12} md={7} style={{paddingRight: "0.5rem"}}>
                <ImageCanvas
                    image={props.adjudication?.biometricFaceData}
                    clickable
                    rectangle={props.adjudication?.operation?.boundingRect}
                />
            </Grid>
            <Grid item xs={12} md={5}>
                <OverviewInfo
                    modality={Modality.FACE_MODALITY}
                    operation={(props.adjudication.operation as Operation)}
                    adjudication
                    issueAge={props.adjudication?.adjudicationPending?.issues?.find(i => i === "ISSUE_AGE")? true : false}
                    issueLiveness={props.adjudication?.adjudicationPending?.issues?.find(i => i === "ISSUE_LIVENESS")? true : false}
                    finalDecision={props.adjudication?.adjudicationSolved?.finalDecision}
                    issues={props.adjudication?.adjudicationSolved?.issues}
                />
            </Grid>
            <Grid container style={{marginTop: "1rem"}}>
            </Grid>
        </Grid>
    )
}

export default AdjudicationOverview